// styling
import { AvatarSize } from "../Avatar";
import styles from "./profile.module.scss";
import { ProfileInfoCard } from "./profileInfoCard";

interface Props {
  name: string;
  profile: string;
  phoneNumber: string;
  welcomeText?: string;
  onClick?: (e: unknown) => void;
  avatarSize?: AvatarSize;
  nationalIdVerified?: boolean;
}

const Profile = ({
  name,
  phoneNumber,
  welcomeText = "",
  profile,
  avatarSize = AvatarSize["MEDIUM"],
  onClick,
  nationalIdVerified,
}: Props) => {
  return (
    <div onClick={onClick && onClick} className={styles.container}>
      <ProfileInfoCard
        name={name}
        profile={profile}
        welcomeText={welcomeText}
        phoneNumber={phoneNumber}
        isNavBar={false}
        avatarSize={avatarSize}
        nationalIdVerified={nationalIdVerified}
      />
    </div>
  );
};

export default Profile;
